export function zendeskIsLoaded() {
    return !!window["$zopim"];
}
//# sourceMappingURL=zendeskUtils.js.map